// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__17I_w","rootSuccess":"CompleteLink_rootSuccess__2A7uB","rootFailure":"CompleteLink_rootFailure__HuY5u","isDisabled":"CompleteLink_isDisabled__-NWr4"};